/**
 * @generated SignedSource<<df68fe4a87e24a7cb29ff13c754a0316>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_user" | "PdpSharedCondensedSidebarButtons_user" | "PdpSharedPromoCode_user">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_user";
};
export type PdpRespCondensedListedContent_user$key = {
  readonly " $data"?: PdpRespCondensedListedContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "161d1324cedcbd7d91541ba047c1758f";

export default node;
